import React from "react";
import { Card, CardContent } from "@/components/ui/card";

export function KpiCard({ label, value, icon: Icon, sub, testId, color = "primary" }) {
  const colorMap = {
    primary: "text-primary bg-primary/10 border-primary/30",
    accent: "text-[hsl(var(--accent))] bg-[hsl(var(--accent)/0.1)] border-[hsl(var(--accent)/0.3)]",
    warning: "text-[hsl(var(--status-pending))] bg-[hsl(var(--status-pending)/0.1)] border-[hsl(var(--status-pending)/0.3)]",
    success: "text-[hsl(var(--status-completed))] bg-[hsl(var(--status-completed)/0.1)] border-[hsl(var(--status-completed)/0.3)]",
    danger: "text-[hsl(var(--status-cancelled))] bg-[hsl(var(--status-cancelled)/0.1)] border-[hsl(var(--status-cancelled)/0.3)]",
  };
  return (
    <Card className="bg-card border-border shadow-[0_10px_30px_hsl(0_0%_0%/0.35)] transition-[transform,border-color] duration-150 hover:-translate-y-[1px] hover:border-border/80">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-wider text-muted-foreground">{label}</div>
            <div data-testid={testId} className="text-2xl md:text-3xl font-semibold font-mono tabular-nums mt-1">{value}</div>
            {sub && <div className="text-xs text-muted-foreground mt-0.5">{sub}</div>}
          </div>
          {Icon && (
            <div className={`h-10 w-10 rounded-md flex items-center justify-center border ${colorMap[color]}`}>
              <Icon className="h-5 w-5" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
